import { Reveal } from "@/components/Reveal";
import { VIDEO, PHOTO } from "@/lib/assets";

export default function Family() {
  return (
    <section id="famille" data-testid="family-section" className="py-24 md:py-32">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-4 border border-white/10 rounded-2xl -translate-x-4 -translate-y-4" />
              <div className="relative rounded-2xl overflow-hidden border border-white/10">
                <video
                  data-testid="family-video"
                  className="w-full h-[300px] sm:h-[420px] object-cover"
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                  poster={PHOTO.family}
                >
                  <source src={VIDEO.family} type="video/mp4" />
                </video>
                <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
                <p className="absolute bottom-5 left-5 text-xs text-slate-200 font-light italic">
                  Les trajets du quotidien deviennent des souvenirs.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-6">
          <Reveal>
            <span className="overline-tag">La vie réelle</span>
            <h2 className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1] tracking-tight">
              L'automobile, c'est aussi
              <br />
              <span className="gold-text">la famille.</span>
            </h2>
            <p className="mt-7 text-sm sm:text-base text-slate-300 font-light leading-relaxed max-w-xl">
              Derrière chaque véhicule, il y a des départs à l'école, des fins de semaine au chalet, des
              souvenirs qui se construisent sur la route. C'est pourquoi nous prenons chaque recherche au
              sérieux : le bon véhicule, c'est celui qui protège votre famille, respecte votre budget et
              simplifie votre quotidien.
            </p>
            <p className="mt-5 text-sm sm:text-base text-slate-400 font-light leading-relaxed max-w-xl">
              VUS familiaux, véhicules économiques ou berlines sécuritaires — nous trouvons celui qui
              correspond à votre vraie vie.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
